// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomeSelect_Coral_css-1qprcsu-option__7sbCt{
    text-align: left;
}
.CustomeSelect_Coral_css-1vr111p-option__B-zCN{
    text-align: left;
}
.CustomeSelect_Coral_css-1r4vtzz__nNLXD{
    width: 100% !important;
}
.CustomeSelect_Coral_css-48ayfv__aOZay{
    width: 100% !important;
}

input{
    height: inherit
}

.CustomeSelect_Coral_react-select__option__G44WZ{
    font-size: 80% !important;
}

.CustomeSelect_Coral_react-select__option1__IrDCm{
    font-size: 100% !important;
}

.CustomeSelect_Coral_react-select__menu-list__ec5kZ{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}
.CustomeSelect_Coral_ev_filter_icon__fPK\\+V {
    background: #fff !important;
    color: #348393 !important;
}
.CustomeSelect_Coral_ev_filter_icon__fPK\\+V:hover {
    background: #348393 !important;
    color: #fff !important;
}
.CustomeSelect_Coral_card__89Y9Z.CustomeSelect_Coral_align-items-center__4IMqL.CustomeSelect_Coral_lp_br_bus__yvYko {
    border: 1px solid lightgray;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Coral/DigitalInstrumentCluster_Coral/CustomeSelect_Coral.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B","sourcesContent":[".css-1qprcsu-option{\n    text-align: left;\n}\n.css-1vr111p-option{\n    text-align: left;\n}\n.css-1r4vtzz{\n    width: 100% !important;\n}\n.css-48ayfv{\n    width: 100% !important;\n}\n\ninput{\n    height: inherit\n}\n\n.react-select__option{\n    font-size: 80% !important;\n}\n\n.react-select__option1{\n    font-size: 100% !important;\n}\n\n.react-select__menu-list{\n    max-height: 150px !important;\n    -webkit-overflow-scrolling:auto !important;\n}\n.ev_filter_icon {\n    background: #fff !important;\n    color: #348393 !important;\n}\n.ev_filter_icon:hover {\n    background: #348393 !important;\n    color: #fff !important;\n}\n.card.align-items-center.lp_br_bus {\n    border: 1px solid lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"css-1qprcsu-option": `CustomeSelect_Coral_css-1qprcsu-option__7sbCt`,
	"css-1vr111p-option": `CustomeSelect_Coral_css-1vr111p-option__B-zCN`,
	"css-1r4vtzz": `CustomeSelect_Coral_css-1r4vtzz__nNLXD`,
	"css-48ayfv": `CustomeSelect_Coral_css-48ayfv__aOZay`,
	"react-select__option": `CustomeSelect_Coral_react-select__option__G44WZ`,
	"react-select__option1": `CustomeSelect_Coral_react-select__option1__IrDCm`,
	"react-select__menu-list": `CustomeSelect_Coral_react-select__menu-list__ec5kZ`,
	"ev_filter_icon": `CustomeSelect_Coral_ev_filter_icon__fPK+V`,
	"card": `CustomeSelect_Coral_card__89Y9Z`,
	"align-items-center": `CustomeSelect_Coral_align-items-center__4IMqL`,
	"lp_br_bus": `CustomeSelect_Coral_lp_br_bus__yvYko`
};
export default ___CSS_LOADER_EXPORT___;
